import { createStore as createZustandStore } from 'zustand/vanilla';
const DERIVED_CRYPTO_KEY_STORAGE_KEY = 'derived-crypto-key';
const AUTH_META_STORAGE_KEY = 'auth-meta';
export function createSecretDerivationStore(options) {
    const shouldPersist = options?.persist === true;
    // SecureStorage ref — populated by hydrate(), used by actions for persistence
    let secureStorage = null;
    return createZustandStore()((set, get) => ({
        method: null,
        derivedKey: null,
        loginWallet: null,
        hydrated: !shouldPersist,
        derivationStatus: 'idle',
        derivationMessage: '',
        prfSupport: null,
        credentialVersion: 0,
        setLogin: (method, key) => {
            set({ method, derivedKey: key });
            if (secureStorage) {
                secureStorage.storeCryptoKey(DERIVED_CRYPTO_KEY_STORAGE_KEY, key).catch(() => { });
                const meta = { method, loginWallet: get().loginWallet };
                secureStorage.setJSON(AUTH_META_STORAGE_KEY, meta).catch(() => { });
            }
        },
        setLoginWallet: (wallet) => {
            set({ loginWallet: wallet });
            if (secureStorage) {
                const method = get().method;
                if (method) {
                    const meta = { method, loginWallet: wallet };
                    secureStorage.setJSON(AUTH_META_STORAGE_KEY, meta).catch(() => { });
                }
            }
        },
        setDerivationStatus: (status) => set({ derivationStatus: status }),
        setDerivationMessage: (message) => set({ derivationMessage: message }),
        setPrfSupport: (result) => set({ prfSupport: result }),
        bumpCredentialVersion: () => set((s) => ({ credentialVersion: s.credentialVersion + 1 })),
        logout: () => {
            // Null the store reference. The CryptoKey is non-extractable —
            // no raw bytes to zeroize. In-flight closures holding a reference
            // can still derive secrets until GC reclaims the key.
            set({ method: null, derivedKey: null, loginWallet: null });
            if (secureStorage) {
                secureStorage.clear().catch(() => { });
            }
        },
        hydrate: async (storage) => {
            secureStorage = storage;
            try {
                const [derivedKey, meta] = await Promise.all([
                    storage.loadCryptoKey(DERIVED_CRYPTO_KEY_STORAGE_KEY),
                    storage.getJSON(AUTH_META_STORAGE_KEY),
                ]);
                if (derivedKey && meta?.method) {
                    set({
                        method: meta.method,
                        derivedKey,
                        loginWallet: meta.loginWallet ?? null,
                        hydrated: true,
                    });
                    return;
                }
            }
            catch { /* ignore — start fresh */ }
            set({ hydrated: true });
        },
    }));
}
